.incentive-banner-wrap {
  width: 100%;
  display: flex;
  gap: 8px;
  .icon-wrapper {
    flex-shrink: 0;
  }
}
